export default __webpack_public_path__ + "static/media/pokerstars_white.29224f95.png";